import { Toast } from "vant"

// 判断类型集合
export const checkStr = (str, type) => {
  switch (type) {
    case 'number': // 数字 任意数字
      return /^[0-9]*$/.test(str)
    case 'Zhennumber': // 非零的正整数
      return /^[1-9]\d*$/.test(str)
    case 'money': // 金额(小数点2位)
      return /^\d*(?:\.\d{0,2})?$/.test(str)
    case 'numberPhone': // 数字10-11位
      return /^[1-9]\d{9,10}$/.test(str)
    case 'mobileCode': // 6位数字验证码
      return /^[0-9]{6}$/.test(str)
    case 'mobileCode4': // 4位数字验证码
      return /^[0-9]{4}$/.test(str)
    case 'mobile': // 手机号码
      return /^1[3|4|5|6|7|8|9][0-9]{9}$/.test(str)
    case 'tel': // 座机
      return /^(0\d{2,3}-\d{7,8})(-\d{1,4})?$/.test(str)
    case 'card': // 身份证
      return /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/.test(str)
    case 'pwd': // 密码以字母开头，长度在6~18之间，只能包含字母、数字和下划线
      return /^([a-zA-Z0-9_]){6,18}$/.test(str)
    case 'payPwd': // 支付密码 6位纯数字
      return /^[0-9]{6}$/.test(str)
    case 'postal': // 邮政编码
      return /[1-9]\d{5}(?!\d)/.test(str)
    case 'QQ': // QQ号
      return /^[1-9][0-9]{4,9}$/.test(str)
    case 'email': // 邮箱
      return /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/.test(str)
    case 'URL': // 网址 url 域名
      return /(http|ftp|https):\/\/[\w\-_]+(\.[\w\-_]+)+([\w\-\.,@?^=%&:/~\+#]*[\w\-\@?^=%&/~\+#])?/.test(str)
    case 'IP': // IP
      return /((?:(?:25[0-5]|2[0-4]\\d|[01]?\\d?\\d)\\.){3}(?:25[0-5]|2[0-4]\\d|[01]?\\d?\\d))/.test(str)
    case 'date': // 日期时间
      return /^(\d{4})\-(\d{2})\-(\d{2}) (\d{2})(?:\:\d{2}|:(\d{2}):(\d{2}))$/.test(str) || /^(\d{4})\-(\d{2})\-(\d{2})$/.test(str)
    case 'english': // 英文
      return /^[a-zA-Z]+$/.test(str)
    case 'chinese': // 中文
      return /^[\\u4E00-\\u9FA5]+$/.test(str)
    case 'lower': // 小写
      return /^[a-z]+$/.test(str)
    case 'upper': // 大写
      return /^[A-Z]+$/.test(str)
    case 'HTML': // HTML标记
      return /<("[^"]*"|'[^']*'|[^'">])*>/.test(str)
    case 'notNull': // 不能为空
      return /\S/.test(stsr)
    default:
      return true
  }
}

//防止重复点击
export function clickThrottle(clickTimer,isToast = false) {
	let now = +new Date(); // 获取当前时间的时间戳
	let timer = clickTimer; // 记录触发事件的事件戳
	console.log(now)
	console.log(timer) 
	
	if (now - timer < 3000) {
		// 如果当前时间 - 触发事件时的事件 < interVal，那么不符合条件，直接return false，
		// 不让当前事件继续执行下去
		console.log('你点的太快了，请稍后再试')
		if(isToast){
      Toast('你点的太快了，请稍后再试'); 
		}
		return { timer:clickTimer,isTime:false }
	} else { 
		// 反之，记录符合条件触发了事件的时间戳，并 return true，使事件继续往下执行
		console.log('执行')
	    clickTimer = now;
		return { timer:clickTimer,isTime:true }
	} 
} 